export enum DeviceType {
  Mobile,
  Tablet,
  Console,
  SmartTV,
  Wearable,
  Embedded,
}
